import angular from 'angular';
import moment from 'moment';
import { BillableRegistration } from '../model/billableRegistration';
import { guid1 } from '@/shared/utils/guid';

angular.module('cloudX').directive('cxInvoiceBillingPeriod', function() {
  return {
    restrict: 'E',
    template: `<div>
      <div ng-if="vm.readonly && vm.info && vm.info.startDate">
        {{vm.info.startDate | formatDate}} &dash; {{vm.info.endDate | formatDate}}
      </div>
      <form data-editable-form name="periodForm" onbeforesave="vm.sumbit($data)" ng-if="!vm.readonly">
        <a href="" ng-click="periodForm.$show();" ng-show="!periodForm.$visible" class="editable editable-click">
          <span ng-if=" vm.info.startDate" class="form-control-static">
            {{vm.info.startDate | formatDate}} &dash; {{vm.info.endDate | formatDate}}
          </span>
          <i class="fa fa-exclamation-triangle fa-fw text-danger" ng-hide="vm.info.startDate" title="{{(11073|translateList:'exceptioncode')}}"></i>
          <i class="glyphicon glyphicon-pencil" ng-hide="vm.info.startDate"></i>
        </a>
        <div ng-if="periodForm.$visible">
          <div class="row">
            <label class="col-md-1" data-translate="StartDate"></label>
            <div class="col-md-9">
            <a href=""
                editable-bsdate="vm.info.startDate"
                e-datepicker-popup
                e-name="startDate"
                onshow="vm.startDatepickerOpen=!vm.info.startDate"
                e-form="periodForm"
                e-autocomplete="off"
                e-placeholder="{{('StartDate'|translate)}}"
                e-clear-text="{{ 'Clear' | translate }}"
                e-close-text="{{ 'Cancel' | translate }}"
                e-current-text="{{ 'Today' | translate }}"
                onbeforesave="vm.validateStartDate($data)"
                e-required
                e-is-open="vm.startDatepickerOpen"
                e-ng-click="vm.startDatepickerOpen=!vm.startDatepickerOpen">
              {{ vm.info.startDate | formatDate}}
          </a>
          </div>
          </div>

          <div class="row">
            <label class="col-md-1" data-translate="EndDate"></label>

            <div class="col-md-9">
          <a href=""
              editable-bsdate="vm.info.endDate"
              e-datepicker-popup
              e-name="endDate"
              e-form="periodForm"
              e-autocomplete="off"
              e-placeholder="{{('EndDate'|translate)}}"
              e-clear-text="{{ 'Clear' | translate }}"
              e-close-text="{{ 'Cancel' | translate }}"
              e-current-text="{{ 'Today' | translate }}"
              onbeforesave="vm.validateEndDate($data, periodForm.$data)"
              e-required
              e-is-open="vm.endDatepickerOpen"
              e-ng-click="vm.endDatepickerOpen=!vm.endDatepickerOpen">
            {{ vm.info.endDate | formatDate}}
          </a>
          </div>
          </div>
        </div>
        <div class="buttons"  ng-show="periodForm.$visible">
          <span>
            <button type="submit" class="btn btn-inverse btn-xs" ng-disabled="periodForm.$waiting" data-translate>Save</button>&nbsp;
            <button type="button" class="btn btn-default btn-xs" ng-disabled="periodForm.$waiting" ng-click="periodForm.$cancel()" data-translate>Cancel</button>
          </span>
        </div>
      </form>

    </div>`,
    scope: {
      invoice: '=',
      readonly: '=',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: [
      '$http',
      'appUrls',
      'flySvc',
      'dataCache',
      'translateListFilter',
      function($http, appUrls, flySvc, dataCache, translateListFilter) {
        var vm = this;
        if (!dataCache.getArray('isMasterTenant')) return;
        vm.startDatepickerOpen = false;
        vm.endDatepickerOpen = false;
        vm.showValidation = false;
        vm.$onInit = function() {
          $http
            .get(`${appUrls.api}/api/invoice/BillingPeriod/${vm.invoice.id}`)
            .then(({ data }) => {
              if (data) {
                vm.info = {
                  invoiceId: data.invoiceId,
                  startDate: moment.utc(data.startDate).toDate(),
                  endDate: moment.utc(data.endDate).toDate(),
                };
              } else {
                vm.info = {
                  invoiceId: vm.invoice.id,
                  startDate: null,
                  endDate: null,
                };
              }
            });
        };
        vm.validateStartDate = function(value) {
          if (!value) return translateListFilter('16002', 'exceptioncode');
          if (!moment.isDate(value)) return translateListFilter('16002', 'exceptioncode');
          return true;
        };
        vm.validateEndDate = function(value, formData) {
          if (!value) return translateListFilter('16002', 'exceptioncode');
          if (!moment.isDate(value)) return translateListFilter('16002', 'exceptioncode');
          if (moment.utc(value).isBefore(moment.utc(formData.startDate)))
            return translateListFilter('16002', 'exceptioncode');
          return true;
        };
        vm.sumbit = function(data) {
          vm.showValidation = true;
          if (!data) return '';
          if (!data.startDate) return '';
          if (!data.endDate) return '';

          const model = {
            ...vm.info,
            startDate: data.startDate.ISO(),
            endDate: data.endDate.ISO(),
            invoiceId: vm.invoice.id,
          };
          return $http.put(`${appUrls.api}/api/invoice/BillingPeriod/`, model).then(
            () => {
              if (vm.invoice.invoiceErrors) {
                const idx = vm.invoice.invoiceErrors.findIndex(x => x.code === 11073);
                if (idx >= 0) vm.invoice.invoiceErrors.splice(idx, 1);
              }
              return true;
            },
            error => {
              flySvc.error(error);
              return '';
            },
          );
        };
      },
    ],
  };
});
